import { SurveyStates } from '../../../../common/src/enums/SurveyStates';

function getCssVariable(name: string) {
    return getComputedStyle(document.documentElement).getPropertyValue(name);
}

const cache = new Map<SurveyStates, string>();

export function surveyStatusToColorCode(status: SurveyStates): string {
    if (cache.has(status)) {
        return cache.get(status)!;
    }
    const color = getCssVariable(`--survey-status-${status}-color`);
    cache.set(status, color);
    return color;
}
